import { Dialog, EmptyState, Icons } from "construct-ui";
import languageModel from "../../models/language.model";
import ModelManagementModel from "../../models/model-management/model-management.model";
import ViewBase from "../view-base.view";

export default function ModelInformationDialog() {

    ViewBase.call(this);

    const DEFAULT_ONCLOSE = () => { console.log('ModelInformationDialog: onClose()') };

    let model = {
        modelCode: '',
        modelAlias: '',
        brand: '',
        basic: '',
        productHierarchy: '',
        status: '',
        description: '',
        attributes: [
            { code: '', name: '' },
        ],
        createBy: '',
        createDate: '',
        updateBy: '',
        updateDate: ''
    };

    const getModelById = (modelCode) => {
        ModelManagementModel.getModelByCode(modelCode)
            .then((result) => {
                model = result;
            })
            .catch((error) => {
                this.handleError(error);
            })
    }

    return {
        oninit: ({ attrs: { modelCode } }) => {
            if (modelCode) {
                getModelById(modelCode);
            }
        },
        view: ({ attrs: { onClose = DEFAULT_ONCLOSE } }) => m(Dialog, {
            class: 'cui-dialog-xl',
            isOpen: true,
            closeOnOutsideClick: false,
            closeOnEscapeKey: false,
            onClose,
            title: languageModel.getText('LT00000900', 'Model Information (Managed By GSCM)'),
            content: m('.card',
                m('.card-body',
                    m('.row.g-2',
                        m('.col-3.fw-bold', languageModel.getText('LT00000728', 'Model Code')),
                        m('.col-3', model.modelCode),
                        m('.col-3.fw-bold', languageModel.getText('LT00000898', 'Model Alias')),
                        m('.col-3', model.modelAlias),
                        m('.col-3.fw-bold', languageModel.getText('LT00000894', 'Brand')),
                        m('.col-3', model.brand),
                        m('.col-3.fw-bold', languageModel.getText('LT00000897', 'Basic')),
                        m('.col-3', model.basic),
                        m('.col-3.fw-bold', languageModel.getText('LT00000902', 'Global Product Group')),
                        m('.col-3', model.productHierarchy),
                        m('.col-3.fw-bold', languageModel.getText('LT00000781', 'Status')),
                        m('.col-3', m(`span.badge.rounded-pill${model.status === '0001' ? '.green-bg-status' : '.danger-bg-status'}`, model.status === '0001' ? languageModel.getText('', 'Active') : languageModel.getText('', 'Inactive'))),
                        m('.col-3.fw-bold', languageModel.getText('LT00000012', 'Description')),
                        m('.col-9', model.description),
                        m('.col-3.fw-bold', languageModel.getText('LT00000899', 'Attribute')),
                        m('.col-9',
                            m('.card', { style: { height: '300px', overflow: 'auto' } },
                                m('.card-body',
                                    model.attributes.length === 0
                                        ? m(EmptyState, {
                                            icon: Icons.ARCHIVE,
                                            content: languageModel.getText("LT00000317", "No results found"),
                                            fill: true,
                                            style: 'color: #B5B5B5',
                                        })
                                        : m('ul.list-group.list-group-flush',
                                            model.attributes.map(({ attribute, value }) => m('li.list-group-item',
                                                m('.row',
                                                    m('.col-6', attribute),
                                                    m('.col-6', value)
                                                )
                                            ))
                                        )
                                )
                            )
                        ),
                        m('.col-3.fw-bold', languageModel.getText('LT00000709', 'Created By')),
                        m('.col-3', model.createBy),
                        m('.col-3.fw-bold', languageModel.getText('LT00000041', 'Create Date')),
                        m('.col-3', model.createDate),
                        m('.col-3.fw-bold', languageModel.getText('LT00000710', 'Updated By')),
                        m('.col-3', model.updateBy),
                        m('.col-3.fw-bold', languageModel.getText('LT00000306', 'Update Date')),
                        m('.col-3', model.updateDate),
                    ),
                    this.getBaseViews()
                )
            ),
            footer: m('.d-flex.justify-content-end', m('button.btn.btn-white', { onclick: onClose }, languageModel.getText('', 'Close')))
        })
    }
}